import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersBusinessSectionsAiBusinessSectionContextsIndexRequestType,
  ApiManagersBusinessSectionsAiBusinessSectionContextsIndexResponseType,
} from "../../types";

type RequestDataType = {
  businessSectionId: string;
  params?: ApiManagersBusinessSectionsAiBusinessSectionContextsIndexRequestType;
  page?: number;
};

const request = async ({
  businessSectionId,
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersBusinessSectionsAiBusinessSectionContextsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersBusinessSectionsAiBusinessSectionContextsIndexResponseType>(
      `/api/managers/business_sections/${businessSectionId}/ai_business_section_contexts`,
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  businessSectionId: string;
  params?: ApiManagersBusinessSectionsAiBusinessSectionContextsIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersBusinessSectionsAiBusinessSectionContextsIndex = ({
  businessSectionId,
  params,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiManagersBusinessSectionsAiBusinessSectionContextsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    [
      "ApisManagersBusinessSectionsAiBusinessSectionContextsIndex",
      businessSectionId,
      params,
    ],
    ({ pageParam }) => {
      return request({
        businessSectionId,
        params,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
